"use client";
import { type Translationtype } from "utils";

interface INavigationProps {
  btnText: string;
  className?: string;
  customTranslate?: boolean;
  onClick: () => void;
  t: Translationtype;
}

export function Navigate({
  onClick,
  btnText,
  customTranslate,
  className,
  t,
}: INavigationProps) {
  return (
    <button
      className={`${className || ""} btn`}
      onClick={() => {
        onClick();
      }}
      type="button"
    >
      {customTranslate ? t(btnText as any) : t(`Buttons.${btnText}` as any)}
    </button>
  );
}
